import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      geoActive: 'global/geoActive',
      geoErr: 'global/geoErr'
    })
  },
  watch: {
    geoErr (text) {
      this.$f7.notification.create({
        icon: '<span class="flat-icon picto-satellite" style="width: 22px; height: 22px;"></span>',
        title: this.t('notifGeoTitle'),
        text: text || this.t('notifGeoError'),
        closeTimeout: 2000
      }).open()
    },
    geoActive (val, old) {
      if (val && old === false) {
        this.$f7.notification.create({
          icon: '<span class="flat-icon picto-satellite" style="width: 22px; height: 22px;"></span>',
          title: this.t('notifGeoTitle'),
          text: this.t('notifGeoSuccess'),
          closeTimeout: 2000
        }).open()
      }
      if (val === false && old === true) {
        this.$f7.notification.create({
          icon: '<span class="flat-icon picto-satellite" style="width: 22px; height: 22px;"></span>',
          title: this.t('notifGeoTitle'),
          text: this.t('notifGeoError'),
          closeTimeout: 2000
        }).open()
      }
    }
  },
  methods: {
    ...mapActions({
      setOnline: 'global/setOnline'
    }),
    network () {
      this.setOnline()
      window.addEventListener('online', () => {
        this.setOnline()
        this.$f7.notification.create({
          icon: '<span class="flat-icon picto-wireless-connectivity" style="width: 22px; height: 22px;"></span>',
          title: this.t('notifDataTitle'),
          text: this.t('notifDataSuccess'),
          closeTimeout: 2000
        }).open()
      })
      window.addEventListener('offline', () => {
        this.setOnline()
        this.$f7.notification.create({
          icon: '<span class="flat-icon picto-wireless-connectivity" style="width: 22px; height: 22px;"></span>',
          title: this.t('notifDataTitle'),
          text: this.t('notifDataError'),
          closeTimeout: 2000
        }).open()
      })
    }
  }
}
